import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_BackButton.scss'
import history from '../../../core/history'
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function isLeftClickEvent (event) {
  return event.button === 0
}

function isModifiedEvent (event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
}

function handleClick (event) {
  history.goBack()

  if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
    return
  }

  if (event.defaultPrevented === true) {
    return
  }

  event.preventDefault()
}

function BackButton ({ buttonText, children, ...remainingProps }) {
  return <Button
    className={styles['back-button']}
    variant={'link'}
    size={'large'}
    {...remainingProps} onClick={handleClick}>
    {buttonText}
    {children}
  </Button>
}

BackButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default (BackButton)
